import type { PrepaidEntry } from './types'

export type PrepaidInputs = {
  amount: number
  durationMonths: number
  startDate: string // ISO YYYY-MM-DD
}

/**
 * Straight-line amortization: monthly = amount / duration. Mirrors
 * frontend/public/prepaid.html calculatePreview exactly.
 */
export function buildAmortizationSchedule({
  amount,
  durationMonths,
  startDate,
}: PrepaidInputs): PrepaidEntry[] {
  if (!(amount > 0) || durationMonths <= 0) return []
  const monthly = amount / durationMonths
  const start = new Date(startDate + 'T00:00:00')
  const rows: PrepaidEntry[] = []
  for (let i = 0; i < durationMonths; i++) {
    const d = new Date(start)
    d.setMonth(start.getMonth() + i)
    const accumulated = (i + 1) * monthly
    const remaining = amount - accumulated
    rows.push({
      period_number: i + 1,
      entry_date: d.toISOString().slice(0, 10),
      amount: round(monthly),
      secondary_amount: 0,
      balance: round(remaining),
      accumulated: round(accumulated),
    })
  }
  return rows
}

function round(n: number): number {
  return Math.round(n * 100) / 100
}
